/** PDF downloads made in the background. Shapes mirror apps/api/src/export-routes.ts. */

import { apiCall, apiDownload, orgPath } from '../api.ts';
import type { RangeSetting } from './reports-api.ts';

export interface ReportExport {
  id: string;
  document_id: string;
  format: 'PDF';
  status: 'QUEUED' | 'RUNNING' | 'DONE' | 'FAILED';
  file_size: number | null;
  error: string | null;
  created_at: string;
  completed_at: string | null;
}

const reports = (org: string, path: string) => orgPath(org, `/reports${path}`);

export const exportsApi = {
  list: (org: string, documentId: string) =>
    apiCall<{ exports: ReportExport[] }>(reports(org, `/documents/${documentId}/exports`)).then(
      (data) => data.exports,
    ),
  request: (org: string, documentId: string, range: RangeSetting) =>
    apiCall<{ export: ReportExport }>(reports(org, `/documents/${documentId}/exports`), {
      method: 'POST',
      body: JSON.stringify({ range }),
    }).then((data) => data.export),
  file: (org: string, id: string) => apiDownload(reports(org, `/exports/${id}/file`)),
};
